module.exports = __webpack_public_path__ + "img/page-not-found.237e2b7a.svg";